import { useContext } from 'react';
import DataContext from "../../context/DataContext.js";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/** Component that handles all  */
export default function BaseGrid(_ref) {
  let {
    rows = true,
    columns = true,
    GridRowsComponent,
    GridColumnsComponent,
    ...props
  } = _ref;
  const {
    theme,
    xScale: columnsScale,
    yScale: rowsScale,
    margin,
    innerWidth,
    innerHeight
  } = useContext(DataContext);
  const gridLineStyles = theme?.gridStyles;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [rows && rowsScale && innerWidth != null && /*#__PURE__*/_jsx(GridRowsComponent, {
      left: margin?.left,
      lineStyle: gridLineStyles,
      width: innerWidth,
      scale: rowsScale,
      ...props
    }), columns && columnsScale && innerHeight != null && /*#__PURE__*/_jsx(GridColumnsComponent, {
      top: margin?.top,
      lineStyle: gridLineStyles,
      height: innerHeight,
      scale: columnsScale,
      ...props
    })]
  });
}